import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { AlertNotification, PushNotification } from '../components/Notifications'
import { notificationsAct } from '../redux/actions'

/**
 * HOC that show alerts & push notifications in the UI.
 *
 * @param {Component} WrappedComponent - Wrapped component in which to show the alerts & pushes.
 * @returns {Component}
 */
export default function (WrappedComponent) {
  // Notifications middleware
  const WithNotifications = ({ notifications, dispatch, ...rest }) => {
    const notificationActions = bindActionCreators(notificationsAct, dispatch)

    return (
      <>
        <WrappedComponent {...rest} />

        <div className='alerts'>
          {notifications.alerts.map(({ id, message, color, button }) => (
            <AlertNotification key={id} message={message} color={color} button={button} toggle={() => notificationActions.removeAlert(id)} />
          ))}
        </div>

        <div className='push-notifications'>
          {notifications.pushes.map(({ id, message, title, icon }) => (
            <PushNotification key={id} message={message} title={title} icon={icon} toggle={() => notificationActions.removePush(id)} />
          ))}
        </div>
      </>
    )
  }

  return connect((state) => ({ notifications: state.notifications }))(WithNotifications)
}
